var exports = {
  "Pf": "MyProfileTabUsernameSection.module__label___VGRCdm",
  "o1": "MyProfileTabUsernameSection.module__actions___VGRCdm",
};

module.exports = exports;
